import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=e309fcde&"
import script from "./Wysiwyg.vue?vue&type=script&lang=ts&"
export * from "./Wysiwyg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports